import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { getMfaV1DashboardBreadcrumbsRoutes } from 'src/common/services/breadcrumbs/MfaUrlService';
import { getProductDashboardAccessPermission } from 'src/common/services/CommonDashboardService';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

export const useSetMfaV1Breadcrumbs = (): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const { location } = useHistory();
	const { getToggle } = useConfiguration();
	const { tenant } = useUserTenant();

	useEffect(() => {
		if (
			location.pathname === RoutesHelper.getMfaV1SessionReportPathname() &&
			getProductDashboardAccessPermission(tenant, getToggle, ProductType.MOBILE_FLOW_ANALYZER)
		) {
			updateBreadcrumbRoutes(getMfaV1DashboardBreadcrumbsRoutes(location));
		}

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [updateBreadcrumbRoutes, setBreadcrumbRoutes, location, tenant, getToggle]);
};
